const muiCardTheme = (theme) => {
  theme.overrides.MuiCard = {
    root: {
      boxShadow: '0px 4px 7px rgba(0, 0, 0, 0.1)',
      borderRadius: '20px',
    },
  };
};

export default muiCardTheme;
